$(function () {
    function getPageName() {
    var pathName = window.location.pathname,
      pageName = "";

    if (pathName.indexOf("/") != -1) {
      pageName = pathName.split("/").pop();
    } else {
      pageName = pathName;
    }

    return pageName;
    }
    let pageName = getPageName();
    console.log({pageName});
});
